import React from 'react';
import { Clock } from 'lucide-react';
export function StickyBar() {
  return <div className="sticky top-0 z-50 bg-navy-dark border-b border-gold/20 py-2.5 px-4" data-id="element-293">
      <div className="max-w-6xl mx-auto flex items-center justify-center gap-2.5" data-id="element-294">
        <Clock className="w-3 h-3 text-gold flex-shrink-0" data-id="element-295" />
        <p className="text-[11px] md:text-sm font-bold tracking-widest uppercase text-gold" data-id="element-296">
          Precio de Lanzamiento &mdash; Plazas Limitadas
        </p>
        <span className="hidden sm:inline-flex items-center gap-1.5 bg-gold/10 border border-gold/25 rounded-full px-2.5 py-0.5 text-[10px] text-gold font-semibold" data-id="element-297">
          <span className="w-1.5 h-1.5 rounded-full bg-gold animate-pulse" data-id="element-298" />
          Activo ahora
        </span>
      </div>
    </div>;
}